import { postData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { useMutation } from "react-query";
import { message } from "antd";
import { IResponse } from "../interfaces/response";

export type TVerifyIdentityResponse = {
  firstName?: string;
  lastName?: string;
  dob?: string | null;
  formatted_dob?: string | null;
  dobDate?: string | null;
  mobile?: string;
  bvn?: string;
  gender?: string;
  residential_address?: string;
  businessName?: string;
  address?: string;
  surname?: string;
  middleName?: string;
  birthdate?: string;
  telephoneNumber?: string;
};

interface VerifyIdentityParams {
  identityNumber?: string;
  identityVerificationType?: string;
  customerType?: string;
  businessType?: any;
}

const verifyIdentity = async ({
  identityNumber,
  identityVerificationType,
  customerType,
  businessType,
}: VerifyIdentityParams): Promise<IResponse<TVerifyIdentityResponse>> => {
  const payload: any = {
    identityNumber,
    identityVerificationType,
    customerType,
  };

  // Only include businessType if provided
  if (businessType) {
    payload.businessType = businessType;
  }

  const { data } = await postData(ajaxEndpoints.DB_VERIFY_IDENTITY, payload);
  return data;
};

export function useVerifyIdentity() {
  const [mutate, result] = useMutation(
    (params: VerifyIdentityParams) => verifyIdentity(params),
    {
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "Failed to verify identity. Please check and try again.";
        message.error(errorMessage);
      },
    }
  );

  return { mutate, result };
}
